import React from 'react';
import { IProps, IStepElems } from './types';

const SurveyStepBar: React.FC<IProps> = (props) => {
  return (
    <div className="survey-step-bar">
      {props.stepElems.map((stepElem: IStepElems, index: number) => {
        const activeClassname = props.currentStep === (index + 1) ? ' survey-step-bar__item--active' : '';
        return (
          <div className={`survey-step-bar__item${activeClassname}`} key={stepElem.index}>
            <div className="survey-step-bar__item-index">{stepElem.index}</div>
            <div className="survey-step-bar__item-text">{stepElem.text}</div>
          </div>
        );
      })}
    </div>
  );
};

export default SurveyStepBar;
